import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {DocumentDataService} from './common/impl/service/ngrx/documentData.service';
import {DocumentRepository} from './common/impl/service/ngrx/document.repository';
import {DocumentTemplateModule} from "./template/documentTemplate.module";
import {errorMessages} from "../core/error/errorMessages";


@NgModule({
    imports: [
        DocumentTemplateModule
    ]
})
export class DocumentModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                documentService: DocumentRepository,
                documentDataService: DocumentDataService,
    ) {

        entityDataService.registerServices({
            Document: documentDataService,
        });

        entityServices.registerEntityCollectionServices({
            Document: documentService,
        });
        errorMessages.set('DOCUMENT_SIGN_ALREADY_SIGNED', 'Le document est déjà signé');
    }
}
